import ResetPasswordView from './reset-password-view';

export default ResetPasswordView;
